import * as svg from "../../../assets/double-chevron-right.svg";

import {iconBuilder} from "./iconBuilder";

export const DoubleChevronRightIcon = iconBuilder(svg, "DoubleChevronRightIcon", "0 0 16 16");
